
var el8 = el8 || {};
if(!el8.main) el8.main = {};
if(!el8.main.ext) el8.main.ext = {};
el8.main.ext.onboardingComplete = {};

if (typeof(_gaq) === "undefined") { _gaq = []; }
el8Globals['OB'] = '/'+'onboarding'+'/'+'1.0'+'/'; // 2012-06

el8.main.ext.onboardingComplete.init = function(appLoginUrl) {
    $('#go-to-app-trigger').on('click', function(e) {
        window.location.href = appLoginUrl;
    });
    $('button[name="share-with-others"]').on('click', function(e) {
        alert('hi!');
    });

    _gaq.push(['_trackPageview', el8Globals['OB']+'signup/complete/']);

};
